var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('x-page',{attrs:{"title":"网友评价"}},[_c('x-waterfall',{attrs:{"load":_vm.handleLoad},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var data = ref.data;
return [_c('BookCommentList',{class:_vm._.list,attrs:{"value":data}})]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }